import { createSlice } from "@reduxjs/toolkit";
import { fetchTransferHistory } from "./thunk";

interface MyTeamState {
  List: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: MyTeamState = {
  List: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const TransferHistorySlice = createSlice({
  name: "TransferHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransferHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.List = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchTransferHistory.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Field Engineer Pending Task";
      });
  },
});

export default TransferHistorySlice.reducer;
